import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonServiceService } from 'src/app/pages/services/common-service.service';
import { ContentService } from '../../services/content.service';
import { MasterFormPopupComponent } from 'src/app/admin/manage-portal/master-form-popup/master-form-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/pages/confirmation-dialog/confirmation-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit, OnChanges {
  sortSelection = '';
  selectedColumn = '';

  constructor(
    private commonService: CommonServiceService,
    private contentService: ContentService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
  ) { }
  @Input() selectedTab: any;
  @Input() headers: any;
  @Input() dataRefresh = false;
  @Output() sortMethod: EventEmitter<any> = new EventEmitter<any>();
  orderSorting = '';
  public limit = 10;
  public skip = 0;
  public page = 1;
  public pageSizeOptions = [5, 10, 25, 50, 100];
  pageIndex = 1;
  totalLength = 0;
  searchString: any = '';
  tableData: any;
  action = [
    {
      actionType: 'edit', icon: 'fa fa-edit', disabled: false, toolTip: 'Edit',
      imgIcon: '/assets/images/edit.svg', isPermission: true, label: 'Update', key: 'update'
    },
    {
      actionType: 'delete', icon: 'fa fa-trash', disabled: false, toolTip: 'Delete',
      imgIcon: '/assets/images/delete-bin.svg', isPermission: true, label: 'Delete', key: 'delete'
    },
  ];

  editAction: any = {
    actionType: 'edit', icon: 'fa fa-edit', disabled: false, toolTip: 'Edit',
    imgIcon: '/assets/images/edit.svg', isPermission: true, label: 'Update', key: 'update'
  };
  deleteAction: any  = {
    actionType: 'delete', icon: 'fa fa-trash', disabled: false, toolTip: 'Delete',
    imgIcon: '/assets/images/delete-bin.svg', isPermission: true, label: 'Delete', key: 'delete'
  };
  @Input() allowedAction: any = [];

  ngOnInit(): void {
  }
  ngOnChanges(changes: SimpleChanges): void {
    // Only refresh when dataRefresh input changes
    if (changes.dataRefresh && changes.dataRefresh.currentValue !== changes.dataRefresh.previousValue) {
      this.searchString = '';
      this.selectedColumn = '';
      this.fetchData();
    }
    // Also refresh when selectedTab changes (tab switch)
    if (changes.selectedTab && changes.selectedTab.currentValue !== changes.selectedTab.previousValue) {
      this.searchString = '';
      this.selectedColumn = '';
      this.fetchData();
    }
  }

  fetchData(isSearch: boolean = false): void {
    this.page = 1;
    this.skip = 0;
    this.limit = 10;
    this.pageIndex = 0;
    this.totalLength = 0;
    this.getTableData(this.selectedTab, isSearch);
  }

  getTableData(selectedTab: any, filters?: boolean): void {
    this.contentService.loaderSubscriber.next(true);
    const queryParams: any = {
      page: this.page,
      limit: this.limit,
    };
    const sortObj = {
      order:  this.orderSorting,
      key: this.selectedColumn
    };
    if (this.orderSorting && this.selectedColumn !== '') {
      Object.assign(queryParams, sortObj);
    }
    if (filters) { queryParams.searchKey = this.searchString; }
    this.commonService.formGetMethod(this.selectedTab?.apiEndPoint, queryParams).subscribe((res: any) => {
      this.contentService.loaderSubscriber.next(false);
      this.tableData = res;
      this.totalLength = res?.total;
    },
      (error: any) => {
        this.contentService.loaderSubscriber.next(false);
      }
    );
  }


  setPage(event: any): void {
    this.skip = (event.pageIndex + 1) * this.limit - this.limit;
    this.limit = event.pageSize;
    this.page = event.pageIndex + 1;
    this.getTableData(this.selectedTab);
  }


  serByName(e: any): void {
     this.fetchData(true);
  }
  openForm(event: any, actionData: any, row: any): void {
    if (actionData?.actionType === 'edit') {
      const createData = {
        title: 'Edit ' + this.selectedTab?.addButtonLabel,
        data: this.selectedTab,
        rowData: row,
        edit : true
      };
      const dialogRefcomp = this.dialog.open(MasterFormPopupComponent, {
        data: createData,
        width: '600px',
        panelClass: 'signUp-dialog-class',
        disableClose: true,
        position: { top: '120px' },
      });
      dialogRefcomp.afterClosed().subscribe((res: any) => {
        if (res?.event === 'dataAdded' || res === true) {
          this.searchString = '';
          this.selectedColumn = '';
          this.fetchData();
        }
      });
    } else {
      this.dialogConfirmation(actionData, '', row);
    }
  }

  dialogConfirmation(eventType?: any, message = 'Are you sure you want to apply changes?', rowData?: any): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message,
        buttonText: {
          ok: 'Yes',
          cancel: 'No',
        },
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        switch (eventType.actionType) {
          case 'delete':
            this.deleteRows(rowData, 'deleteAction');
            break;
          default:

        }
      }
    });
  }

  deleteRows(row: any, action: any): void {
    const body = row;
    body.isActive = false;
    const updateEndPoints = `${this.getActionTab()}/update`;
    this.commonService.formUpdateMethod(body, updateEndPoints, row?.id, action).subscribe((res: any) => {
      this.openSnackBar([res?.message || 'Success !'], '', 'success');
      this.getTableData(this.selectedTab);
    },
      (error: any) => {
        this.openSnackBar([error?.error?.message || 'Failed !'], '');
      }
    );
  }
  getActionTab(): string {
    const selectedKey = this.selectedTab?.key;
    switch (selectedKey) {
      case 'countryMaster':
        return 'country';
      case 'sectorMaster':
        return 'sector';
      case 'msmeMaster':
        return 'msme';
      default:
        return 'msme-classification';
    }
  }
  openSnackBar(message: any, action = '', className = 'parmary'): void {
    this.snackBar.open(message, action, {
      duration: 3000,
      panelClass: [className]
    });
  }
  clearFilter(): void {
    this.searchString = '';
    this.skip = 0;
    this.getTableData(this.selectedTab);
  }
  sortTable(columnName: string, sortType: string = ''): void {
    this.sortSelection = sortType;
    this.selectedColumn = columnName;
    this.orderSorting = sortType === 'down' ? 'DESC' : 'ASC';
    const event = {
      limit: this.limit,
      page: this.page,
      order:  this.orderSorting,
      key: columnName
    };
    this.commonService.formGetMethod(this.selectedTab?.apiEndPoint, event).subscribe((res: any) => {
      this.contentService.loaderSubscriber.next(false);
      this.tableData = res;
      this.totalLength = res?.total;
    },
      (error: any) => {
        this.contentService.loaderSubscriber.next(false);
      }
    );
  }
}
